<template>
  <div>
<!--        <headTop/>-->
        <div class="mainbox_border">
            <section class="m0 cb pt15 " :style="{minHeight:minHeight + 'px'}">
<!--                <personalLeft/>-->
                <!--右侧内容-->
                <article class="rightMenu oh">
                    <router-view></router-view>
                </article>
            </section>
        </div>
<!--        <ft/>-->
  </div>
</template>
<style>
.content{height: auto;overflow:hidden;}
.mainbox_border .content .el-pager li{width: 32px!important;height: 32px!important;min-width:32px!important;line-height: 32px;margin: 0 8px!important;
font-weight: normal;font-size: 16px;padding: 0px;background: none;}
.mainbox_border .content .el-pager li.active,.mainbox_border .content .el-pager li:hover{ background: #1b3f75;border-radius: 50%;padding: 0px;color: #fff;}
.mainbox_border .content .el-pagination button,.mainbox_border .content .el-pagination__total{height: 32px!important;line-height: 32px!important;}
.mainbox_border .content  .el-pagination__sizes,.mainbox_border .content  .el-pagination__jump{display: none;}
.mainbox_border .content .el-pagination{text-align: center;}
.mainbox_border .content .el-pagination .btn-next,.mainbox_border .content .el-pagination .btn-prev{background: none;}
</style>

<script>
// import ft from "./Footer"
// import headTop from "./Top"
// import personalLeft from "./PersonalLeft"
export default {
  name: 'App',
  data(){
    return{
      minHeight:0
    }
  },
  // components:{
  //   ft,
	// headTop,
  // 	personalLeft
  // },
	methods:{

  },
   mounted(){
        this.minHeight = document.documentElement.clientHeight -205
        var that = this
        window.onresize = function(){
            that.minHeight = document.documentElement.clientHeight -205
        }
    }
}
</script>



// WEBPACK FOOTER //
// PersonalMain.vue?3e4df465